module.exports = __webpack_public_path__ + "img/ic_close.4f375fcd.svg";